import { useEffect, useState } from "react";

const dataStatus = "data-status";

const cleanListeners = (script, setStateFromEvent) => {
	if (script) {
		script.removeEventListener("load", setStateFromEvent);
		script.removeEventListener("error", setStateFromEvent);
	}
};

const addScriptTag = (position, script, prepend) => {
	if (position) {
		if (prepend) {
			document[position].prepend(script);
		} else {
			document[position].appendChild(script);
		}
	}
};

const useScriptBase = (src, position, text, id, prepend) => {
	const [status, setStatus] = useState(src ? "loading" : "idle");

	useEffect(() => {
		if (!src && !(text && id)) {
			setStatus("idle");
			return null;
		}

		let script = src ? document.querySelector(`script[src="${src}"]`) : document.querySelector(`script[id="${id}"]`);

		if (!script) {
			script = document.createElement("script");
			if (src) {
				script.src = src;
			} else {
				script.text = text;
				script.id = id;
				script.type = "text/javascript";
			}
			script.async = true;
			script.setAttribute(dataStatus, "loading");

			addScriptTag(position, script, prepend);

			const setAttributeFromEvent = (event) => {
				script.setAttribute(
					dataStatus,
					event.type === "load" ? "ready" : "error"
				);
			};

			script.addEventListener("load", setAttributeFromEvent);
			script.addEventListener("error", setAttributeFromEvent);
		} else {
			setStatus(script.getAttribute(dataStatus));
		}

		const setStateFromEvent = (event) => {
			setStatus(event.type === "load" ? "ready" : "error");
		};

		script.addEventListener("load", setStateFromEvent);
		script.addEventListener("error", setStateFromEvent);

		// Remove event listeners on cleanup
		return () => {
			cleanListeners(script, setStateFromEvent);
		};
	}, [src, position, text, id, prepend]);

	return status;
};

const useScript = (src, position, prepend = false) => {
	return useScriptBase(src, position, "", "", prepend);
};

export const useScriptText = (text, id, position, prepend) => { 
	return useScriptBase("", position, text, id, prepend);
}

export default useScript;
